var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.000977,
    height: 24.001465,
    viewBox: "0 0 24.001 24.0015",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.51 3.51C-1.18 8.2 -1.18 15.79 3.51 20.48L3.74 20.71C7.49 24.25 13.41 24.98 17.95 22.62L18.11 22.53L22.7 23.95L22.81 23.98C23.51 24.12 24.15 23.47 23.97 22.75L22.56 17.12L22.67 16.9C24.88 12.36 24.11 7.14 20.48 3.51C15.87 -1.1 8.45 -1.17 3.75 3.28L3.51 3.51ZM19.07 4.92C22.21 8.07 22.77 12.61 20.62 16.51L20.57 16.63C20.49 16.82 20.47 17.03 20.52 17.24L21.59 21.52L18.29 20.49C18.02 20.41 17.73 20.44 17.48 20.59C13.57 22.91 8.16 22.3 4.92 19.07C1.02 15.16 1.02 8.83 4.92 4.92C8.83 1.02 15.16 1.02 19.07 4.92ZM11.19 8.61L13.37 10.79L7.79 10.79C7.24 10.79 6.79 11.24 6.79 11.79C6.79 12.34 7.24 12.79 7.79 12.79L13.37 12.79L11.19 14.97C10.8 15.36 10.8 15.99 11.19 16.38C11.58 16.77 12.22 16.77 12.61 16.38L16.49 12.5C16.49 12.5 16.49 12.5 16.5 12.5C16.89 12.1 16.89 11.47 16.5 11.08L12.61 7.19C12.22 6.8 11.58 6.8 11.19 7.19C10.8 7.58 10.8 8.22 11.19 8.61Z",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComment);
export default __webpack_public_path__ + "static/media/ic_comment.28d1b0ac26bed7f157763f2802e9a917.svg";
export { ForwardRef as ReactComponent };